/* eslint-disable @next/next/no-img-element */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useRouter } from "next/navigation";
import HomeOffers from "./homeOffers";

interface BannerItem {
  id: number;
  title?: string;
  description?: string;
  image: string;
  url?: string | null;
  banner_links?: Array<{
    id: number;
    linkable_type?: string | null;
    linkable_id?: number;
    banner_management_id?: number;
    type?: string;
  }>;
}

interface HomeBannerProps {
  banners?: BannerItem[];
  isForYouTab?: boolean;
}

function HomeBanner({ banners = [], isForYouTab = true }: HomeBannerProps) {
  const router = useRouter();
  type Slider = any;
  const sliderRef = useRef<Slider | null>(null);

  // Don't render if no banners
  if (!banners || banners.length === 0) {
    return null;
  }

  // Add autoplay and autoplaySpeed to settings for auto scroll
  const settings = {
    infinite: banners.length > 1,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 2000, // 2 seconds
  };

  const handleBannerClick = (banner: BannerItem) => {
    if (banner.url) {
      router.push(banner.url);
    } else if (banner.banner_links && banner.banner_links.length > 0) {
      const hasAllKeys = banner.banner_links.every(
        (link) => link?.linkable_id && link?.linkable_type && link?.type
      );

      if (hasAllKeys) {
        const firstLink = banner.banner_links[0];
        if (firstLink.type === "brand") {
          router.push(
            `/product/product-category?brandIds=${banner.banner_links
              .map((link) => link?.linkable_id)
              .join(",")}`
          );
        } else if (firstLink.type === "category") {
          router.push(
            `/product/product-category?categoryIds=${banner.banner_links
              .map((link) => link?.linkable_id)
              .join(",")}`
          );
        } else if (firstLink.type === "product") {
          router.push(
            `/product/product-category?productIds=${banner.banner_links
              .map((link) => link?.linkable_id)
              .join(",")}`
          );
        } else {
          router.push("/product/product-category?type=recommended");
        }
      } else {
        router.push("/product/product-category?type=recommended");
      }
    }
  };

  return (
    <>
      <section className="home_banner">
        <div className="container">
          <Slider ref={sliderRef} {...settings} className="hero_slider">
            {banners.map((banner) => (
              <figure
                key={banner.id}
                onClick={() => handleBannerClick(banner)}
                style={{ cursor: banner.url || (banner.banner_links && banner.banner_links.length > 0) ? 'pointer' : 'default' }}
              >
                <img
                  src={banner.image}
                  alt={banner.title || banner.description || "banner"}
                  style={
                    !isForYouTab
                      ? { maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }
                      : undefined
                  }
                />
              </figure>
            ))}
          </Slider>
        </div>
      </section>
    </>
  );
}

export default HomeBanner;
